import { h } from 'preact'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import { Badge, User } from './interfaces'

export const LeaderboardUserListTable = ({ usersList }: {usersList: Array<User>}) => {
  return (
    <div className='leaderboard-table-container'>
      <table className='leaderboard-table'>
        <thead>
          <LeaderboardHeaderRow />
        </thead>
        <tbody>
          {usersList.map(user => { return <LeaderboardUserRow {...user} /> })}
        </tbody>
      </table>
    </div>
  )
}

export const LeaderboardPlaceholderTable = () => {
  const placeholderArray = [1, 2, 3]
  return (
    <div className='leaderboard-table-container'>
      <table className='leaderboard-table'>
        <thead>
          <LeaderboardHeaderRow />
        </thead>
        <tbody>
          {placeholderArray.map(item => { return <LeaderboardPlaceholderRow leaderboardPosition={item} /> })}
        </tbody>
      </table>
    </div>
  )
}

export const LeaderboardEmptyMessage = () => (
  <div className='leaderboard-empty-message-container'>
    <div className='leaderboard-empty-message'>
      <h5 className='leaderboard-empty-message-title'>There’s no one on the leaderboard yet </h5>
      <div>The weekly leaderboard resets at midnight CET on Sundays. Now's your chance to take the lead!</div>
    </div>
  </div>
)

const LeaderboardPlaceholderRow = ({ leaderboardPosition }: {leaderboardPosition: number}) => {
  return (
    <tr className='leaderboard-row placeholder-row'>
      <td className='ranking-cell right'><Icon icon='medal' customClass='icon-medal is-hidden-S' /> <span className='ranking-number'> {leaderboardPosition} </span></td>
      <td className='user-cell'>
        <div className='user-details-container'>
          <div className='user-icon-container'><Icon icon='user' width={40} height={40} customClass='icon-user' /></div>
          <div className='user-details'>
            <div className='user-placeholder' />
            <div className='points-mobile' />
          </div>
        </div>
      </td>
      <td className='points-cell'><div className='points-placeholder is-hidden-S' /> <Icon icon='medal' customClass='icon-medal mobile-medal-icon' /> </td>
      <td className='rank-title-cell is-hidden-S is-hidden-tablet'><div className='user-details' /></td>
      <td className='badges-cell is-hidden-S is-hidden-tablet' />
    </tr>
  )
}

const LeaderboardUserRow = ({ id, name, avatar, points, leaderboardPosition, rank, rankTitle, badgeList }: User) => {
  let userData = {
    id: id,
    name: name,
    avatar: avatar,
    rank: {
      avatarIconUrl: rank
    }
  }
  const isMedalVisible = leaderboardPosition <= 3
  return (
    <tr className='leaderboard-row'>
      <td className='ranking-cell right'> {isMedalVisible && <Icon icon='medal' customClass={`icon-medal icon-medal-${leaderboardPosition} is-hidden-S`} /> }
        <span className='ranking-number'> {leaderboardPosition} </span></td>
      <td className='user-cell'>
        <div className='user-details-container'>
          <div className='user-icon-container'><UserAvatar user={userData} showRank style={{ display: 'block' }} /></div>
          <div className='user-details'>
            <UserName user={userData} extraClass='username' />
            <div className='points-mobile'>{ <Phrase m='Forum' p='{n} point| {n} points' count={{ n: points.toString() }} /> }</div>
          </div>
        </div>
      </td>
      <td className='points-cell'>
        <div className='points-placeholder is-hidden-S'> {points} </div>
        {isMedalVisible && <Icon icon='medal' customClass={`icon-medal mobile-medal-icon icon-medal-${leaderboardPosition}`} />}
      </td>
      <td className='rank-title-cell is-hidden-S is-hidden-tablet'>{rankTitle}</td>
      <td className='badges-cell is-hidden-S is-hidden-tablet'><BadgesColumn badges={badgeList} /></td>
    </tr>
  )
}

const LeaderboardHeaderRow = () => (
  <tr className='leaderboard-header-row is-hidden-S'>
    <td className='ranking-cell right'>RANKING</td>
    <td className='user-cell'>USER</td>
    <td className='points-cell'>POINTS</td>
    <td className='rank-title-cell is-hidden-S is-hidden-tablet'>RANK</td>
    <td className='badges-cell is-hidden-S is-hidden-tablet'>BADGES</td>
  </tr>
)

const BadgesColumn = ({ badges }: { badges?: Array<Badge> }) => {
  if (badges === undefined) {
    return null
  }
  const badgeCount = badges.length
  const numberOfBadgesToDisplay = 5
  return <div className='badges-icon-container'>
    <div>
      {badges.map((badge, idx: number) => {
        return idx < numberOfBadgesToDisplay ? <img className='badge-icon' src={badge.icon} title={badge.title} /> : null
      })}
    </div>
    <div> {badgeCount <= numberOfBadgesToDisplay ? null : `+${badgeCount - numberOfBadgesToDisplay}` }</div>
  </div>
}
